import * as React from 'react';

import { useMemberSession } from '@/auth/auth-provider';

import { goingCountLabel } from '../event-discovery/constants';

import { useAttendeeRoster } from './api';

/**
 * **The hero's *N going* pill** — `Web App.dc.html` §2.2, beside the atmosphere pill:
 * `700/var(--text-2xs)` on `--surface-sunken` in `--text-body`, `padding:5px 12px`.
 *
 * The count is the roster module's own `goingCount` (`MEM-011` AC-3), read from the same query
 * Who's coming reads — one request, one figure, and the heading in the sidebar and this pill
 * cannot disagree. The roster route answers a signed-in member who is not registered with that
 * count (and nobody), which is exactly what Sumit's ruling of 2026-09-11 leaves them.
 *
 * Nothing for a signed-out visitor (`MEM-019` AC-2 — the route is behind a session, so nothing is
 * asked), nothing while it loads, and never a zero: `goingCountLabel` answers `null` for both,
 * which is the Discover card's rule (`MEM-014` AC-2) applied to the same figure.
 */
export function GoingPill({ eventId }: { readonly eventId: string }): React.ReactElement | null {
  const { session } = useMemberSession();
  const query = useAttendeeRoster(eventId, { enabled: session !== null });
  const label = goingCountLabel(query.data?.roster.goingCount);
  if (session === null || label === null) return null;
  return (
    <span className="rounded-pill bg-muted px-3 py-[5px] font-brand text-2xs font-bold text-text-body">
      {label}
    </span>
  );
}
